import script from "./LocSearchSci.vue?vue&type=script&setup=true&lang=js"
export * from "./LocSearchSci.vue?vue&type=script&setup=true&lang=js"

import "./LocSearchSci.vue?vue&type=style&index=0&id=33f038d0&lang=scss&scoped=true"

import exportComponent from "E:\\Projects\\big-screen\\ori\\nnu-data-viewer-1204\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33f038d0"]])

export default __exports__